import { helper } from '@ember/component/helper';

function isNullOrUndefined([obj]) {
  return obj === null || obj === undefined;
}

export default helper(isNullOrUndefined);
